import { Stack, Text, useMantineTheme, Box, Group, createStyles } from '@mantine/core'
import React, { useMemo } from 'react'
import { useLottie } from 'lottie-react'
import { LottieAnimations } from 'src/assets'
import { useMediaQuery } from '@mantine/hooks'

export interface HeroContentProps {}

const useStyles = createStyles(theme => ({
  wavingImageStyle: {
    // transformStyle: rotate('45deg'),
    div: {
      width: 40,
      height: 40,
    },
  },
}))

export const HeroContent: React.FC<HeroContentProps> = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const { classes } = useStyles()

  const { wavingHand } = LottieAnimations.Hero

  const { View: WavingHand } = useLottie({
    animationData: wavingHand,
    loop: false,
    autoplay: true,
  })

  const greetingMessage = useMemo(() => {
    const currentHour = new Date().getHours()
    if (currentHour < 12) {
      return 'Morning'
    } else if (currentHour < 16) {
      return 'Afternoon'
    } else {
      return 'Evening'
    }
  }, [])

  return (
    <Stack align={isMobile ? 'center' : 'flex-start'} justify={isMobile ? 'center' : 'flex-start'}>
      <Group>
        <Text size="xl">Hi, Wish you {greetingMessage}</Text>
        <Box className={classes.wavingImageStyle}>{WavingHand}</Box>
      </Group>
      <Text size={isMobile ? 40 : 80} weight={700} variant="gradient" gradient={{ from: 'blue', to: 'cyan' }}>
        I'm Tirth Patel
      </Text>
    </Stack>
  )
}
